import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@mui/material';

function SearchInput({
  value,
  onChange,
  size,
  disabled,
}) {
  return (
    <Input
      type="search"
      variant="standard"
      value={value}
      onChange={(e) => onChange(e, e.target.value)}
      size={size}
      disabled={disabled}
      startAdornment={<FontAwesomeIcon icon={faSearch} size="1x" color="grey" />}
      color="primary"
      fullWidth
      placeholder="Пошук"
      inputProps={{ sx: { ml: 1 } }}
    />
  );
}

SearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'small']),
  disabled: PropTypes.bool,
};

SearchInput.defaultProps = {
  value: '',
  size: 'small',
  disabled: false,
};

export default SearchInput;
